import { render, staticRenderFns } from "./KioskWeightModal.vue?vue&type=template&id=69f1a60a&"
import script from "./KioskWeightModal.vue?vue&type=script&lang=js&"
export * from "./KioskWeightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports